export const noDistanceNoteTypes = ['freestyle', 'rap'];
export const noPointsNoteTypes: string[] = [];

export const MIDDLEA = 440;
export const SEMITONE = 69;

export const MAX_NAME_LENGTH = 20;

// What a clean Easy round earns - every note on pitch and held perfectly - before any bonus. Vibrato,
// combos and a harder difficulty all score on top of it, so a round can go past it.
export const MAX_POINTS = 3_500_000;

// Keyed by the engine tolerance: 1 Hard, 2 Medium, 3 Easy. The debug widths above Easy earn Easy's.
export const DIFFICULTY_SCORE_MULTIPLIERS: Record<number, number> = { 1: 1.3, 2: 1.15, 3: 1 };

export const difficultyScoreMultiplier = (tolerance: number) => DIFFICULTY_SCORE_MULTIPLIERS[tolerance] ?? 1;

// Highest first. A hit note earns the multiplier of the run it extends, so the fifth note in a row is
// the first at x1.1. The labels are what the score card shows while the run lasts.
export const COMBO_TIERS = [
  { from: 50, label: 'LEGENDARY', multiplier: 1.5 },
  { from: 30, label: 'ON FIRE', multiplier: 1.3 },
  { from: 15, label: 'HOT', multiplier: 1.2 },
  { from: 5, label: 'STREAK', multiplier: 1.1 },
] as const;
